"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const listComponentsUseCase_1 = require("@/useCases/components/listComponentsUseCase");
const AddComponentModal_1 = __importDefault(require("./components/ComponentForms/AddComponentModal"));
const EditComponentModal_1 = __importDefault(require("./components/ComponentForms/EditComponentModal"));
const ComponentToast_1 = __importDefault(require("./components/ComponentToast"));
const index_view_1 = __importDefault(require("./index.view"));
function Components() {
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        (0, listComponentsUseCase_1.listComponents)()(dispatch);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(index_view_1.default, null),
        react_1.default.createElement(AddComponentModal_1.default, null),
        react_1.default.createElement(EditComponentModal_1.default, null),
        react_1.default.createElement(ComponentToast_1.default, null)));
}
exports.default = Components;
